export default __webpack_public_path__ + "static/media/jim.6f28cd93.jpg";